const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Articles Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 */

app.controller('editAssessment', ['Application', 'Authorization', 'Assessments', 'AccessHelper', 'AdminContent', 'Analyze', 'Viewables', 'Companies', '$scope', '$translate', '$location', 'AssessmentLib', '$sce', function(Application, Authorization, Assessments, AccessHelper, AdminContent, Analyze, Viewables, Companies, $scope, $translate, $location, AssessmentLib, $sce) {
    var self = this;
    self.authtoken = Authorization.getAuthToken();
    self.features = Application.features.flags();

    self.user = self.authtoken.user;
    self.videoAssessments = Application.features.flags().video_assessments || false;

    var routeParameters = Application.navigation.getRouteParameters();
    var newAssess = routeParameters.id === 'new' || !routeParameters.id;
    self.allowance = {
      create_assessment: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'assessments_create']], ['admin', 'creator', 'collaborator']),
      edit_assessment: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'assessments_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
      add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!newAssess && !self.allowance.edit_assessment) || (newAssess && !self.allowance.create_assessment)) {
      Application.navigation.goTo('/explore');
      return;
    }

    // Set track state to notify user of context

    var trackState = self.trackState = Application.trackState.get();
    // Track state is passed through local storage and has a ttl
    if (trackState && trackState.ttl < new Date().valueOf()) {
      trackState = self.trackState = false;
    }

    if (trackState) {
      // Sets a banner for track state
      if (routeParameters.id === 'new' || !routeParameters.id) {
        $translate('edit.assessment.trackmessage_add', {title: trackState.trackTitle})
            .then(function(value) {
              Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
            });
      } else {
        $translate('edit.assessment.trackmessage_edit', {title: trackState.trackTitle})
            .then(function(value) {
              Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
            });
      }
    }

    self.navigationPath = {};
    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.info.editSaved && !self.navigation.holdNav) {
        // Allow the route change to progress
        self.denied = true;
        Application.messaging.clearMessages('trackstate');
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.info.showDeparture = true;
      self.onLocationChange = function() {
        locationChange();
        Application.messaging.clearMessages('trackstate');
      };
    });

    self.froalaOptions = {
      key: '4NC5fF6A3D4H3H3C4B-16UJHAEFZMUJOYGYQEa2d2ZJd1RAeF3C8B5C4E3C3B2G3A14A7==',
      charCounterCount: false,
      toolbarSticky: false,
      attribution: false,
      height: 600,
      imageDefaultWidth: 600,
      toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'color', 'emoticons', 'paragraphStyle', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'insertLink', 'undo', 'redo', 'customClear'],
      linkInsertButtons: ['linkBack'],
      charCounterMax: 500,
      quickInsertButtons: ['table', 'ul', 'ol', 'hr','embedly']
    };

    self.navigation = {
      activeTab: 'assessmentType',
      returnToAfterPreview: 'settings',
      holdNav: false,
      showPreview: false,
      next: function(tab) {
        if (tab === 'preview') {
          self.navigation.returnToAfterPreview = self.navigation.activeTab;
        }

        if (self.navigation.holdNav) {
          if (!self.assessment || !self.assessment.questions || !self.assessment.questions.length) {
            if (!tab || (tab !== 'details' && tab !== 'questions')) {
              Application.messaging.addMessage({type: 'info', text: self.translations['edit.assessment.add_question'], duration: 5});
              return;
            }
          } else {
            Application.messaging.addMessage({type: 'info', text: self.translations['edit.assessment.save_cancel_question'], duration: 5});
            return;
          }
        }

        if (!tab) {
          if (!self.navigation.activeTab || !self.navigation.directory[self.navigation.activeTab] || !self.navigation.directory[self.navigation.activeTab].next) {
            return;
          }
          tab = self.navigation.directory[self.navigation.activeTab].next;
          if (self.navigation.directory[self.navigation.activeTab].next === 'preview') {
            self.navigation.returnToAfterPreview = self.navigation.activeTab;
          }
        }

        var directoryItem = self.navigation.directory.assessmentType;
        function checkDirectory() {
          if (directoryItem.passRequired && !directoryItem.passRequired()) {
            return false;
          }
          if (!directoryItem.next || directoryItem.next === tab) {
            return true;
          }
          if (!self.navigation.directory[directoryItem.next]) {
            return false;
          }

          directoryItem = self.navigation.directory[directoryItem.next];
          return checkDirectory();
        }
        ;

        if (checkDirectory()) {
          self.navigation.activeTab = tab;
          Application.scrollTop();
        }
      },
      directory: {
        'assessmentType': {
          next: 'details',
          previous: null,
          passRequired: function() {
            if (self.info.newAssessment && !self.info.typeChosen) {
              return false;
            }
            return true;
          }
        },
        'details': {
          next: 'questions',
          previous: null,
          passRequired: function() {
            if (!self.assessment.title || !self.assessment.description || !self.assessment.creator_name) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_fields']});
              return false;
            }
            return true;
          }
        },
        'questions': {
          next: 'settings',
          previous: 'details',
          passRequired: function() {
            if (!self.assessment.questions || !self.assessment.questions.length) {
              if (self.assessment.video_assessment) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_video_prompt']});
              } else if (self.assessment.file_assessment) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_upload_prompt']});
              } else {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_question']});
              }
              return false;
            }

            if (!self.comms.checkNoBlankPages()) {
              return false;
            }
            
            if (self.assessment.file_assessment) {
              let questionOptions = self.assessment.questions[0].question_options;
              for (let i = 0; i < questionOptions.length; i++ ) {
                if(questionOptions[i].name === 'upload_type'){
                  if(!questionOptions[i].value.length) {
                    Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_file_type']});
                    return false;
                  }
                }
              }
            }
            if (self.assessment.video_assessment || self.assessment.file_assessment) {
              if (!self.assessment.questions[0].question) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: (self.assessment.video_assessment ? self.translations['edit.assessment.req_video_prompt'] : self.translations['edit.assessment.req_upload_prompt'])});
                return false;
              }
              if (self.assessment.questions[0].rubric_grading) {
                if (self.assessment.questions[0].rubric_options && self.assessment.questions[0].rubric_options.length) {
                  for (var i = 0; i < self.assessment.questions[0].rubric_options.length; i++) {
                    if (!self.assessment.questions[0].rubric_options[i].name || !self.assessment.questions[0].rubric_options[i].description) {
                      Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_rubric']});
                      return false;
                    }
                  }
                }
              }
            }
            return true;
          }
        },
        'settings': {
          next: 'preview',
          previous: 'questions',
          passRequired: null
        },
        'preview': {
          next: null,
          previous: 'settings',
          passRequired: null
        }
      },
      goBack: function() {
        if (trackState && trackState.track) {
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          return;
        }
        Application.navigation.goTo('/overview/assessments');
      },
      specialClose: function() {
        self.navigation.next(self.navigation.returnToAfterPreview);
      }
    };


    // ** REMINDER - Need to add leave page warnings

    self.showCollaborators = false;
    self.info = {
      editSaved: true,
      typeChosen: false,
      hasManualGrade: false,
      updateIndicator: false,
      showArchive: false,
      states: [],
      newAssessment: routeParameters.id === 'new' || !routeParameters.id,
      stockAssessment: {
        title: '',
        description: '',
        questions: [],
        pages: 1,
        tags: [],
        assigned_graders: [],
        allow_manager_grading: true,
        assign_manager_grading: false,
        allow_buddy_grading: false,
        assign_buddy_grading: false,
        allow_retake: false,
        number_of_retakes: 0,
        percent_to_pass: 0,
        video_assessment: false,
        file_assessment: false,
        privacy_collaborators: [],
        hide_cover: false
      },
      fields: 'company,user,questions,title,description,archived,private,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,image,banner_image,cover_justification,featured_justification,explore_hide,tags,published,assigned_graders,allow_manager_grading,allow_buddy_grading,assign_manager_grading,assign_buddy_grading,allow_retake,number_of_retakes,percent_to_pass,video_assessment,file_assessment,show_user_grade,show_user_correct,show_user_correct_after_fail,creator_name,content,certificate,certificate_data,hide_cover,partner_permissions',
      passingValues: [],
      retakeValues: [],
      allowRetake: function(yes) {
        if (yes) {
          self.info.noRetake = !self.info.noRetake;
          if (!self.info.noRetake && !self.info.yesRetake) {
            self.info.yesRetake = true;
          }
        }
        if (!yes) {
          self.info.yesRetake = !self.info.yesRetake;
        }

        if (self.info.yesRetake) {
          self.assessment.number_of_retakes = self.assessment.number_of_retakes || 1;
          return;
        }
        self.assessment.number_of_retakes = 0;
      },
      checkManual: function() {
        if (!self.assessment || !self.assessment.questions || !self.assessment.questions.length) {
          self.info.hasManualGrade = false;
        }
        for (var i = 0; i < self.assessment.questions.length; i++) {
          var opts = AssessmentLib.helpers.getQuestionOptions(self.assessment.questions[i]);
          if (!opts) {
            continue;
          }
          if (opts.manual_grade) {
            self.info.hasManualGrade = true;
            return;
          }
        }
        self.info.hasManualGrade = false;
      },
      typeChangeQuestionStates: {
        video: null,
        file: null,
        questions: null
      },
      setType: function(type) {
        self.info.typeChosen = true;
        var prevType = 'questions';
        if (self.assessment && self.assessment.video_assessment) {
          prevType = 'video';
        }
        if (self.assessment && self.assessment.file_assessment) {
          prevType = 'file';
        }
        if (type === 'video' || type === 'file') {
          if (self.assessment.questions && self.assessment.questions.length) {
            if (self.navigation.holdNav) {
              // dont save the quiz questions if in a hold state
              self.navigation.holdNav = false;
            } else if (prevType) {
              self.info.typeChangeQuestionStates[prevType] = self.assessment.questions.slice(0);
            }
          }
          if (type === 'video') {
            if (self.info.typeChangeQuestionStates.video) {
              self.assessment.questions = self.info.typeChangeQuestionStates.video;
            } else {
              self.videoQuestion.addNew();
            }
          }
          if (type === 'file') {
            if (self.info.typeChangeQuestionStates.file) {
              self.assessment.questions = self.info.typeChangeQuestionStates.file;
            } else {
              self.fileQuestion.addNew();
            }
          }
        }

        if (!type) {
          if (self.assessment.questions && self.assessment.questions.length && prevType) {
            self.info.typeChangeQuestionStates[prevType] = self.assessment.questions.slice(0);
          }
          if (self.info.typeChangeQuestionStates.questions) {
            self.assessment.questions = self.info.typeChangeQuestionStates.questions;
          }
        }
        self.assessment.video_assessment = type === 'video' ? true : false;
        self.assessment.file_assessment = type === 'file' ? true : false;
        self.activeType = type;
        self.navigation.activeTab = 'details';
      },
      checkManagerAllow: function() {
        if (self.assessment.assign_manager_grading) {
          self.assessment.allow_manager_grading = true;
        }
      },
      checkBuddyAllow: function() {
        if (self.assessment.assign_buddy_grading) {
          self.assessment.allow_buddy_grading = true;
        }
      }
    };

    self.videoQuestion = {
      stock: {
        id: AssessmentLib.helpers.makeId(),
        page: 0,
        position: 0,
        format: 'video',
        question: '',
        choice_options: [],
        question_options: [
          {
            name: 'manual_grade',
            value: true
          },
          {
            name: 'question_value_is_custom',
            value: true
          },
          {
            name: 'choose_attempt',
            value: true
          },
          {
            name: 'manual_points',
            value: 1
          },
          {
            name: 'recording_limit',
            value: 5
          },
          {
            name: 'recording_type',
            value: 'web_cam_video'
          }
        ]
      },
      addNew: function() {
        var newQuestion = Object.assign({
          rubric_grading: true,
          rubric_options: [
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_1']), description: $sce.valueOf(self.translations['edit.assessment.description_1']), points: 1},
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_2']), description: $sce.valueOf(self.translations['edit.assessment.description_2']), points: 1},
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_3']), description: $sce.valueOf(self.translations['edit.assessment.description_3']), points: 1}
          ]
        }, self.videoQuestion.stock);
        self.assessment.questions = [newQuestion];
      }
    };

    self.fileQuestion = {
      stock: {
        id: AssessmentLib.helpers.makeId(),
        page: 0,
        position: 0,
        format: 'file',
        question: '',
        choice_options: [],
        question_options: [
          {
            name: 'manual_grade',
            value: true
          },
          {
            name: 'question_value_is_custom',
            value: true
          },
          {
            name: 'manual_points',
            value: 1
          },
          {
            name: 'upload_type',
            value: 'pdf'
          }
        ]
      },
      addNew: function() {
        var newQuestion = Object.assign({
          rubric_grading: true,
          rubric_options: [
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_1']), description: $sce.valueOf(self.translations['edit.assessment.description_1']), points: 1},
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_2']), description: $sce.valueOf(self.translations['edit.assessment.description_2']), points: 1},
            {id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_3']), description: $sce.valueOf(self.translations['edit.assessment.description_3']), points: 1}
          ]
        }, self.fileQuestion.stock);
        self.assessment.questions = [newQuestion];
      }
    };

    // Start Build Value Options
    var addValue = function(value, name, list) {
      list.push({
        name: name,
        value: value
      });
    };

    for (var i = 0; i <= 100; i = i + 5) {
      addValue(i, i + '%', self.info.passingValues);
    }

    for (var i = 1; i < 6; i = i + 1) {
      addValue(i, i, self.info.retakeValues);
    }

    self.comms = {
      archive: function() {
        if (self.info.newAssessment) {
          return;
        }

        Assessments.update({
          subresource: self.assessment._id,
          fields: 'archived'
        }, {archived: true}).$promise.then(function(item) {
          Analyze.record({resource: 'modifications'}, {document: item._id, type: 'assessment'});
          Application.analyticsProvider.trackEvent('assessment_updated', {content: item._id, content_type: 'assessment', title: item.title});
          self.info.updateIndicator = false;
          Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['edit.assessment.archived']});
          locationChange();
          Application.navigation.goTo('/overview/assessments');
        }).catch(function(err) {
          self.info.updateIndicator = false;
          console.log('Error in update: ', err);
        });
      },
      checkMinimum: function() {
        if (!self.assessment.questions || !self.assessment.questions.length) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_question']});
          return false;
        }

        for (var i = 0; i < self.assessment.questions.length; i++) {
          var question = self.assessment.questions[i];
          if (!question || !question.rubric_grading) {
            continue;
          }

          if (!question.question_options || !question.question_options.length) {
            // error for points for non rubric
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_points']});
            return false;
          }

          for (var i = 0; i < question.rubric_options.length; i++) {
            var item = question.rubric_options[i];
            if (!item) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_rubric_filled']});
              return false;
            }
            if (!item.name || !item.points || !item.description) {
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.req_rubric_name']});
              return false;
            }
          }
        }

        return true;
      },
      checkNoBlankPages: function() {
        // Create an array of empty page question counts
        let pageQuestionCounts = []
        for (let i = 0; i < self.assessment.pages; i += 1) {
          pageQuestionCounts.push(0)
        }

        // Increment question count for each page
        self.assessment.questions.forEach((question) => pageQuestionCounts[question.page] += 1 )

        // Check if any pages have no questions
        if (pageQuestionCounts.some((count) => count === 0)) {
          Application.messaging.addMessage({ type: 'error', duration: 5, text: self.translations['edit.assessment.no_blank_pages'] })

          return false
        }

        return true
      },
      create: function() {
        self.info.updateIndicator = true;

        // Check requirements
        if (!self.comms.checkMinimum()) {
          return;
        }

        self.assessment.user = self.user._id;

        if (self.trackState) {
          self.assessment.content = {
            content_type: 'Track',
            content_id: self.trackState.track
          };
        }
        if(self.user.is_collaborator) {
          self.assessment.approval_required = true;
          self.assessment.approved = false;
        }
        Assessments.create(self.assessment).$promise
        .then(function(item) {
          Analyze.record({resource: 'creations'}, {document: item._id, type: 'assessment'});
          Application.analyticsProvider.trackEvent('assessment_created', {content: item._id, content_type: 'assessment', title: item.title});
          self.info.updateIndicator = false;
          Application.messaging.addMessage({type: 'success', text: self.translations['edit.assessment.created'], duration: 5});
          self.assessment = item;
          self.info.newAssessment = false;
          self.info.states.push(JSON.parse(JSON.stringify(self.assessment)));
          self.info.editSaved = true;
          locationChange();
          if (trackState) {
            trackState.contentId = self.assessment._id;
            trackState.contentTitle = self.assessment.title;
            Application.trackState.set(trackState);
            self.editSaved = true;
            Application.navigation.goTo('/edit/tracks/' + trackState.track);
            return;
          }
          Application.navigation.goTo('/overview/assessments');
        }).catch(function(err) {
          self.info.updateIndicator = false;
          if (err.data && err.data.status === 401 && err.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: err.data.message});
            return;
          }
          console.log('Error in update: ', err);
        });
      },
      clickSave: function() {
        // Check requirements
        if (!self.comms.checkMinimum() || !self.comms.checkNoBlankPages()) {
          return;
        }

        self.comms.save()
            .then(function() {
              if (trackState) {
                locationChange();
                Application.navigation.goTo('/edit/tracks/' + trackState.track);
                return;
              }
            });
      },
      save: function(postSave) {
        // Check requirements
        if (!self.comms.checkMinimum()) {
          return;
        }

        self.info.updateIndicator = true;
        if(self.user.is_collaborator) {
          self.assessment.approval_required = true;
          self.assessment.approved = false;
        }

        return Assessments.update({
          subresource: self.assessment._id,
          fields: self.info.fields
        }, self.assessment).$promise.then(function(item) {
          Analyze.record({resource: 'modifications'}, {document: item._id, type: 'assessment'});
          Application.analyticsProvider.trackEvent('assessment_deleted', {content: item._id, content_type: 'assessment', title: item.title});
          self.info.updateIndicator = false;
          self.info.states.push(JSON.parse(JSON.stringify(item)));
          self.assessment = item;
          Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['edit.assessment.saved']});
          if (postSave && typeof postSave === 'function') {
            postSave();
          }
          setTimeout(function() {
            self.info.editSaved = true;
          }, 650);
        }).catch(function(err) {
          self.info.updateIndicator = false;
          if (err.data && err.data.status === 401 && err.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: err.data.message});
            return;
          }
          console.log('Error in update: ', err);
        });
      }
    };
  
    self.partners = {
      partnerPermission: 'tenant',
      changePermission: (permission) => {
        self.partners.partnerPermission = permission;
      }
    }

    var setWatches = function() {
      $scope.$watch('assessment.assessment.allow_manager_grading', function(newVal, oldVal) {
        if (oldVal && !newVal) {
          self.assessment.assign_manager_grading = false;
        }
      });
      $scope.$watch('assessment.assessment.allow_buddy_grading', function(newVal, oldVal) {
        if (oldVal && !newVal) {
          self.assessment.assign_buddy_grading = false;
        }
      });
      $scope.$watch('assessment.assessment.allow_retake', function(newVal, oldVal) {
        if (!oldVal && newVal) {
          self.assessment.number_of_retakes = self.assessment.number_of_retakes || 1;
        }
      });
      $scope.$watch('assessment.assessment.show_user_grade', function(newVal, oldVal) {
        if (oldVal && !newVal) {
          self.assessment.show_user_correct = false;
        }
      });
      $scope.$watch('assessment.assessment.show_user_correct', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.assessment.show_user_grade = true;
        }
      });
      $scope.$watch('assessment.partners.partnerPermission', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.assessment.partner_permissions = newVal;
      }, true);
    };
    self.isCollaborator = function() {
      return Authorization.isCollaborator();
    };
    self.initialize = function() {
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }

      if (!Authorization.hasValidAuthToken()) {
        if (Application.navigation.isRouteSecure()) {
          locationChange();
          Application.navigation.goToSignIn();
          return;
        }
      }

      Companies.get({fields: 'video_assessment_limits'}).$promise
      .then(function (results) {
        self.companyLimits = results.video_assessment_limits || {};
      });

      self.info.newAssessment = routeParameters.id === 'new' || !routeParameters.id;
      if (self.info.newAssessment) {
        self.assessment = self.info.stockAssessment;
        if (self.user.is_collaborator) {
          self.assessment.privacy_collaborators.push(self.user._id);
        }
        setWatches();
        self.info.editSaved = false;
        self.startEditWatch();
        return;
      }
      self.navigation.activeTab = 'details';
      AdminContent.get({
        subresource: routeParameters.id,
        fields: self.info.fields,
        types: 'assessments'
      }, function(data) {
        if (!data || (data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.trackNotEditable'], duration: 5});
          self.editSaved = true;
          Application.navigation.goToHome();
          return;
        }
        self.assessment = data;

        // Set assessment page count
        if (self.assessment.questions && self.assessment.questions.length) {
          self.assessment.pages = self.assessment.questions.reduce((max, question) => Math.max(max, question.page + 1), 1)
        }
        
        if (!self.assessment.privacy_collaborators) {
          self.assessment.privacy_collaborators = [];
        }
        if (self.assessment.privacy_collaborators.length && !self.user.is_collaborator) {
          self.showCollaborators = true;
        }
        if (self.assessment.partner_permissions) {
          self.partners.partnerPermission = self.assessment.partner_permissions;
        }
        self.info.checkManual();
        setWatches();
        self.info.editSaved = true;
        self.startEditWatch();
      }, function(error) {
        // Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.unableToFindArticle'], duration: 5});
      });
    };

    self.startEditWatch = function() {
      $scope.$watch('assessment.assessment', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.info.editSaved = false;
      }, true);
    };

    $translate([
      'edit.assessment.add_question',
      'edit.assessment.save_cancel_question',
      'edit.assessment.req_fields',
      'edit.assessment.req_video_prompt',
      'edit.assessment.req_question',
      'edit.assessment.req_rubric',
      'edit.assessment.req_rubric',
      'edit.assessment.name_1',
      'edit.assessment.description_1',
      'edit.assessment.name_2',
      'edit.assessment.description_2',
      'edit.assessment.name_3',
      'edit.assessment.description_3',
      'edit.assessment.unlimited',
      'edit.assessment.archived',
      'edit.assessment.req_points',
      'edit.assessment.req_rubric_filled',
      'edit.assessment.req_rubric_name',
      'edit.assessment.created',
      'edit.assessment.saved',
      'edit.assessment.unlimited',
      'edit.assessment.req_upload_prompt',
      'edit.assessment.req_file_type',
      'edit.assessment.no_blank_pages'
    ]).then(function(translations) {
      self.translations = translations;
      addValue(1000, self.translations['edit.assessment.unlimited'], self.info.retakeValues);
    });

    self.initialize();

  }]);
